var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _LoadingSpinner = _interopRequireDefault(require("../components/Universal/Basic/LoadingSpinner"));

var _Basic = require("../elements/Basic");

var _Error = _interopRequireDefault(require("../components/Universal/Basic/DataFetching/Error"));

var _NoData = _interopRequireDefault(require("../components/Universal/Basic/DataFetching/NoData"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/hoc/withDataFetch.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var withDataFetch = function withDataFetch(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits2.default)(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class() {
      (0, _classCallCheck2.default)(this, _class);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(_class, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _isEqual.default)(this.props, nextProps);
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;

        if (props.isLoading) {
          return _react.default.createElement(_Basic.Column, {
            width: props.width,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 24,
              columnNumber: 21
            }
          }, _react.default.createElement(_LoadingSpinner.default, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 25,
              columnNumber: 25
            }
          }));
        } else if (props.error) {
          return _react.default.createElement(_Error.default, {
            width: props.width,
            error: props.error,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 29,
              columnNumber: 24
            }
          });
        }

        return props.isEmpty ? _react.default.createElement(_NoData.default, {
          width: props.width,
          messageKey: props.messageKey,
          messageValue: props.messageValue,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 33,
            columnNumber: 17
          }
        }) : _react.default.createElement(Component, (0, _extends2.default)({}, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 39,
            columnNumber: 17
          }
        }));
      }
    }]);
    return _class;
  }(_react.default.Component), _class.displayName = Component.displayName || Component.name || 'WithDataFetch', _class.propTypes = _objectSpread({}, Component.propTypes), _temp;
};

var _default = withDataFetch;
exports.default = _default;